import type {
  CreateIntegrationsSyncRunSyncParametersInput,
  SyncValidationsSyncParametersInput,
  SyncableStateStatisticsParametersInput,
} from 'generated/resources/graphql'

export type SyncParameters =
  | CreateIntegrationsSyncRunSyncParametersInput[]
  | SyncValidationsSyncParametersInput[]
  | SyncableStateStatisticsParametersInput[]

export type Parameters = Record<string, string>

export const toSyncParameters = (params: Parameters): SyncParameters => {
  return Object.entries(params).map(([key, value]) => ({ key, value }))
}
